import React, { useEffect } from "react";
import styled from "styled-components";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import useAuth from "./hooks/useAuth";
import TopBar from "./TopBar";
import useLogout from "./hooks/useLogout";
// import { useIntl } from "react-intl";
// import { useLanguage } from "../context/LanguageContext";

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const ContentContainer = styled.div`
  flex: 1;
  padding: 0px 20px;
`;

function LandingPage() {
  // const intl = useIntl();
  // const { changeLanguage } = useLanguage();

  const { auth } = useAuth();

  const logout = useLogout();
  const navigate = useNavigate();
  const location = useLocation();

  const decoded = auth?.accessToken ? jwtDecode(auth.accessToken) : undefined;

  useEffect(() => {
    // const from = location.state?.from?.pathname || "/";
    if (location.pathname === "/") {
      navigate("/requests", { replace: true });
    }
  }, [location, navigate]);

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <AppContainer>
      <TopBar userName={decoded?.userName} onLogout={handleLogout} />
      {/* 
        <h1>
          {intl.formatMessage({ id: "welcome" })} {decoded?.userName}
        </h1>
        <Button onClick={() => changeLanguage("en")}>English</Button>
        <Button onClick={() => changeLanguage("fr")}>French</Button>
       */}
      <ContentContainer>
        <Outlet />
      </ContentContainer>
    </AppContainer>
  );
}

export default LandingPage;
